"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleOmittedDays = exports.useMonthlyBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const MonthlyCalendar_1 = require("./MonthlyCalendar");
const shared_1 = require("./shared");
const date_fns_1 = require("date-fns");
const MonthlyBodyContext = react_1.default.createContext(null);
function useMonthlyBody() {
    return (0, react_1.useContext)(MonthlyBodyContext);
}
exports.useMonthlyBody = useMonthlyBody;
const handleOmittedDays = ({ days, omitDays, locale, }) => {
    let headings = (0, shared_1.daysInWeek)({ locale });
    let daysToRender = days;
    //omit the headings and days of the week that were passed in
    if (omitDays) {
        headings = (0, shared_1.daysInWeek)({ locale }).filter((day) => !omitDays.includes(day.day));
        daysToRender = days?.filter((day) => !omitDays.includes((0, date_fns_1.getDay)(day)));
    }
    // omit the padding if an omitted day was before the start of the month
    let firstDayOfMonth = (daysToRender && (0, date_fns_1.getDay)(daysToRender[0])) || 0;
    let lastDayOfMonth = (daysToRender && 6 - (0, date_fns_1.getDay)(daysToRender[daysToRender.length - 1])) || 0;
    if (omitDays) {
        let subtractOmittedDays = omitDays.filter((day) => day < firstDayOfMonth).length;
        firstDayOfMonth = firstDayOfMonth - subtractOmittedDays;
    }
    let paddingBeginning = new Array(firstDayOfMonth).fill(0);
    let paddingEnd = new Array(lastDayOfMonth).fill(0);
    return { headings, daysToRender, paddingBeginning, paddingEnd };
};
exports.handleOmittedDays = handleOmittedDays;
//to prevent these from being purged in production, we make a lookup object
const headingClasses = {
    l3: "grid-cols-3",
    l4: "grid-cols-4",
    l5: "grid-cols-5",
    l6: "grid-cols-6",
    l7: "grid-cols-7",
};
exports.default = ({ omitDays, children, }) => {
    const calendar = (0, MonthlyCalendar_1.useMonthlyCalendar)();
    let { headings, daysToRender, paddingBeginning, paddingEnd } = (0, exports.handleOmittedDays)({
        days: calendar?.days,
        omitDays,
        locale: calendar?.locale,
    });
    let headingClassName = "p-2 block";
    return ((0, jsx_runtime_1.jsx)("div", { className: "text-sm dark:text-gray-400", children: (0, jsx_runtime_1.jsxs)("div", { className: `grid px-4 ${
            //@ts-ignore
            headingClasses[`l${headings.length}`]}`, children: [headings.map((day) => ((0, jsx_runtime_1.jsx)("div", { className: headingClassName, "aria-label": "Day of Week", children: day.label.substring(0, 3) }, day.day))), paddingBeginning.map((_, index) => ((0, jsx_runtime_1.jsx)("div", { className: headingClassName, "aria-label": "Empty Day" }, index))), daysToRender?.map((day) => ((0, jsx_runtime_1.jsx)(MonthlyBodyContext.Provider, { value: {
                        day,
                    }, children: children }, day.toISOString()))), paddingEnd.map((_, index) => ((0, jsx_runtime_1.jsx)("div", { className: headingClassName, "aria-label": "Empty Day" }, index)))] }) }));
};
